import {
  NonFousableTooltipTarget,
  Tooltip,
  TooltipTrigger,
} from "@/components/tooltip";

import type { AccountTagConfig } from "../constants/accountTags";

interface AccountTagIconProps {
  config: AccountTagConfig;
}

export function AccountTagIcon({ config }: AccountTagIconProps) {
  const Icon = config.icon;

  return (
    <TooltipTrigger delay={200}>
      <NonFousableTooltipTarget>
        <div
          className={`flex items-center justify-center size-6 rounded-full ${config.bgColor} ${config.color}`}
        >
          {config.iconSrc ? (
            <img alt={config.label} className="size-4" src={config.iconSrc} />
          ) : Icon ? (
            <Icon className="size-4" strokeWidth={2} />
          ) : null}
        </div>
      </NonFousableTooltipTarget>
      <Tooltip>{config.tooltip}</Tooltip>
    </TooltipTrigger>
  );
}
